import { render, staticRenderFns } from "./BusinessAnalysis.vue?vue&type=template&id=680d502a&scoped=true"
import script from "./BusinessAnalysis.vue?vue&type=script&lang=js"
export * from "./BusinessAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BusinessAnalysis.vue?vue&type=style&index=0&id=680d502a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d502a",
  null
  
)

export default component.exports